import paczkomatyHtml from './paczkomaty.component.html';
import './paczkomaty.component.scss';

class PaczkomatyController {
    constructor($scope, PaczkomatyService, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.service = PaczkomatyService;
        this.CartService = CartService;

        this.selectedMachine = null;
        this.selectedMachineName = null;
        this.localLoading = true;

        this.cities = [];
        this.citiesQuery = '';
        this.machines = [];
        this.easyPack = null;
    }

    get customOptions() {
        const options = {};

        options.selected = this.selectedMachine;

        return options;
    }

    $onInit() {

        this.initEasyPack();

        this.service.loadCities(this.payment.pay_on_delivery).then(
            (cities) => {
                this.cities = cities;

                this.service.getStatus().then(
                    (data) => {
                        if (data.machine && data.machine.city && data.machine.name) {
                            this.citiesQuery = data.machine.city;
                            this.service.getMachines(data.machine.city, this.payment).then(
                                (machines) => {
                                    this.machines = machines;

                                    const matches = this.machines.filter(machine => machine.machine == data.machine.name);

                                    if (matches.length > 0) {
                                        matches[0].preselected = true;
                                        this.selectedMachine = matches[0];
                                        this.selectedMachineName = matches[0].machine;

                                        this.CartService.shipmentOptions.paczkomaty = this.customOptions;
                                    }

                                    this.localLoading = false;
                                },
                                () => {
                                    this.localLoading = false;
                                }
                            );
                        } else {
                            this.localLoading = false;
                        }
                    },
                    () => {
                        this.localLoading = false;
                    }
                );
            },
            () => {
                this.localLoading = false;
            }
        );
    }


    initEasyPack() {
        if (!this.easyPack) {
            const geoScript = document.createElement('script');
            geoScript.type = 'text/javascript';
            geoScript.src = 'https://geowidget.easypack24.net/js/sdk-for-javascript.js';
            document.getElementsByTagName('head')[0].appendChild(geoScript);

            const geoCss = document.createElement('link');
            geoScript.rel = 'stylesheet';
            geoScript.href = 'https://geowidget.easypack24.net/js/sdk-for-javascript.js';
            document.getElementsByTagName('head')[0].appendChild(geoCss);

            window.easyPackAsyncInit = () => {
                easyPack.init({
                    defaultLocale: 'pl',
                    mapType: 'osm',
                    searchType: 'osm',
                    points: {
                        types: ['parcel_locker']
                    },
                    map: {
                        initialTypes: ['parcel_locker']
                    }
                });
                this.easyPack = easyPack;
            };
        }
    }
    openGeoModal() {
        let that = this;
        this.easyPack.modalMap(function (point, modal) {

            modal.closeModal();
            that.setMachine(point.name);

        }, { width: 500, height: 600 });
    }

    getMachines(city) {
        this.localLoading = true;
        this.machines = [];
        this.selectedMachine = null;

        this.saveCustomOptions();
        this.service.getMachines(city.value, this.payment).then(
            (machines) => {
                this.machines = machines;
                this.localLoading = false;
            },
            () => {
                this.localLoading = false;
            }
        );
    }

    setMachine(machine) {
        this.localLoading = true;
        this.selectedMachineName = this.selectedMachine = machine;

        this.service.setMachine(machine).then(
            (machine) => {
                this.saveCustomOptions();
                this.localLoading = false;
            },
            () => {
                this.selectedMachine = null;
                this.localLoading = false;
            }
        );
    }

    saveCustomOptions() {
        this.save({
            shipment: this.shipment,
            options: this.customOptions
        });
    }

    clear() {
        this.citiesQuery = '';
        this.machines = [];
        this.selectedMachine = null;
    }
}

let paczkomatyComponent = {
    bindings: {
        loading: '<',
        shipment: '<',
        payment: '<',
        selected: '<',
        save: '&'
    },
    template: paczkomatyHtml,
    controller: PaczkomatyController
}

export default paczkomatyComponent;
